import React from 'react';

import type { WorkflowNodeProps } from 'flow/service/graph';
import ConstructionNode from '../ConstructionNode';


/**
 * The canvas should show a "tail" coming in from the left-side of the screen into imported nodes.
 * React-flow does not allow to have floating edges; all edges need to be from node to node.
 * This node is rendered out of the canvas at the same Y position as the imported node, and allows
 * for the edge to be rendered from them to imported nodes.
 */
function ImportedTailNode(props: WorkflowNodeProps) {
  return <ConstructionNode {...props} />;
}

export default React.memo(ImportedTailNode);
